import React, { useEffect, useState } from 'react';
import Loader from '../Common/loader';
import FormHeading from '../../UI_Design/FormComponents/Heading/FormHeading';
import RadioButtonGroup from '../../UI_Design/FormComponents/RadioAndLabel/RadioButtonGroup';
// import { useDispatch } from 'react-redux';
// import { saveCourtRecordDeclaration } from '../../../Actions/courtRecordAction'; // Example action
import TextField from '../OnbordingForm/TabsAndContent/textField';
import { saveCourtRecordCheckData } from '../../Actions/CourtRecordCheckActions';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import FormFields from './formFields';
import StepCount from '../Common/StepCount';
import { toast } from 'react-toastify';

const MainFormForm16 = (props) => {
    const {formData, candidateDetails, allCheckData, uploadedFilesCount, documnetMandatory} = props
    const [isLoading, setIsLoading] = useState(false);
    const [hasCourtRecord, setHasCourtRecord] = useState(null); // Track Yes/No selection
    const [address, setAddress] = useState('');
    const [cnrNumbers, setCnrNumbers] = useState('');
    const [fields, setFields] = useState({});
    const [candidateData, setCandidateData] = useState({})
    const [saveData, setSavePayload] = useState({});
    const [errData, setErrData] = useState({});
    const [activeTab, setActiveTab] = useState(1);
  
    
    const dispatch = useDispatch();
    const navigate = useNavigate();

    let user = JSON.parse(localStorage.getItem('userVerificationCandidate'));
    let clientId;
  
    if(user && (user?.client_id || user?.bridge_client_id)){
      clientId = user?.client_id || user?.bridge_client_id;  
    }

    useEffect(() => {
        if(formData && formData?.declarationFormFields){
            setFields(formData?.declarationFormFields);
            setCandidateData(formData?.formData);

        }
    },[formData])

    const handleRadioButtonChange = (index, id, selectedOption, option) => {
        setHasCourtRecord(index === 0); // Assuming "Yes" is the first option (index 0)
        setSavePayload((prev) => ({
            ...prev,
            [id] : option
        }))
    };

    const handleInputChange = (val) => {

        var cols = document.getElementById(val[0].err_id);
        cols.innerHTML = "";
        
        setSavePayload((prev) => ({
            ...prev,
            [val[0]?.id] : val[0]?.value
        }))
        
        // if(name[0]?.name == 'address'){
        //     setAddress(name[0]?.value);
        // }

        // if(name[0]?.name == 'CNR'){
        //     setCnrNumbers(name[0]?.value);
        // }
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        let err = formValidation();

        
        if(err == true){
            window.scroll({ top: 0, left: 0, behavior: "smooth" });
        }else{

            
            let recordData = {};
            let saveFields = {...saveData};

            if (hasCourtRecord == true) {
                const declarationAddress = fields?.declaration_address;
                saveFields[declarationAddress?.id] = ''
            } else {
                const declarationCnrNumber = fields?.declaration_cnr_number;
                saveFields[declarationCnrNumber?.id] = ''
            }
            
            const obj = {
                group: "declaration_details",
                ...saveFields
            };
            

        // recordData.check_data = { [caseCheckId]: { "group": "address", ...newRecord, ...additonalData } };
        recordData.check_data = { [formData?.declarationFormFields?.case_check_id]: obj };
        recordData.case_check_id = formData?.declarationFormFields?.case_check_id;
        
        console.log(recordData);
        dispatch(saveCourtRecordCheckData(recordData, saveCallback));
    }

    };

    const saveCallback = (data) => {

        const group = data.group ? data.group.group_id : "";
        const hasNextCheck = data.nextCheck != "" ? true : false;
        const reference = data.reference_number;

        if (
            group == "profile_preview" ||
            data.group == "profile_preview"
          ) {
            navigate(`/case-initiation/profile-preview/${reference}`);
          } else if (typeof group != "undefined" && group != "") {
            navigate(`/case-initiation/check-detail/${reference}/${group}`);
          }
    }


    const formValidation = () => {
        let isError = false;
      
        // Resetting all errors first
        const errorElements = document.getElementsByClassName("err text-danger");
        for (let i = 0; i < errorElements.length; i++) {
          errorElements[i].innerHTML = "";
        }
      
        // Check if the court record field is required
        if (!hasCourtRecord == true) {
          const declarationAddress = fields?.declaration_address;
          if (declarationAddress?.is_mandatory == 1) {
            isError = validateField(declarationAddress);
          }
        } else {
          const declarationCnrNumber = fields?.declaration_cnr_number;
          if (declarationCnrNumber?.is_mandatory == 1) {
            isError = validateField(declarationCnrNumber);
          }
        }
      
        // Return true if there are any errors, false otherwise
        return isError;
      };

              // Reusable function to handle field validation
        const validateField = (field, errorMessage = "This field is required.") => {
          const fieldId = field?.id;
          const elementErrorId = `err-${fieldId}`;
          const fieldValue = saveData?.[fieldId];
      
          if (
            fieldValue === undefined ||
            fieldValue === null ||
            fieldValue.trim() === ""
          ) {
            const errorElement = document.getElementById([elementErrorId]);
            if (errorElement) {
              errorElement.innerHTML = errorMessage;
            //   isError = true;
            return true;
            }
          }
        };

        const handleSubmitForPreview = (e) => {
            e.preventDefault();
            const currentUrl = window.location.href;
            const [partA, partB] = currentUrl.split("/check-detail/");
            const [reference, route] = partB.split("/");
            navigate(`/case-initiation/profile-preview/${reference}`);
          };

          const checkAllPreviousCheckCompleted = (limitIndex) => {
            const inCompleteIndex = allCheckData?.findIndex((check) => check?.check_status === 1);
            if(inCompleteIndex > -1 && inCompleteIndex < limitIndex-1) {
              return false;
            }
            return true;
          }

          const handleTabClick = (index, uploadFlag) => {

            // return if current tab is not submited
            // if(index == activeTab){
            //   return;
            // }

            if(checkAllPreviousCheckCompleted(index)){ 
              setActiveTab(index);
            }else{
                toast.dismiss();
                toast.error("Please save the current form to proceed.", {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
                // e?.stopPropagation();
            }
            
            
            // let flag = localStorage.getItem("disableEditDigi");
            // flag == 'true' && education?.transation_id && education?.transation_id != "" ? setAllDisabled(true) : setAllDisabled(false);
        
            // let url = window.location.href.split('/');
            // if(index < activeTab){
            //   setActiveTab(index);
            //   if(url.length> 0 && url[url.length - 1] == 'uploadDigi'){
            //     url.pop();
            //     // navigate(url.join('/'))
            //   navigate(`/case-initiation/check-detail/${reference}/3`)
        
            //   }
            //   return;
            // }
        
            // if(education && (education.checksDetails[activeTab - 1]?.check_status == 2 || education.checksDetails[activeTab - 1]?.check_status == 3)){
            // let flag = localStorage.getItem("digiResponse");
            // if(uploadFlag){
            //     let allCheckSumbitted = true;
            //     education && Object.values(education.checksDetails).map((data,index) => {
            //       if(data?.check_status == 1 ){
            //         allCheckSumbitted = false;
            //       }
            //     })
            //     if(allCheckSumbitted){
            //       setActiveTab(index);
            //       navigate('./uploadDigi');
            //     }else{
            //       let err = 'Please save all education forms'
            //       toast.error(err, {
            //         position: "top-right",
            //         autoClose: 5000,
            //         hideProgressBar: false,
            //         closeOnClick: true,
            //         pauseOnHover: true,
            //         draggable: true,
            //         progress: undefined,
            //       });
            //     }
            //   }else{
            //     if(education.checksDetails[index - 2]?.check_status == 2 || education.checksDetails[index - 2]?.check_status == 3){
            //       setActiveTab(index);
            //       // navigate('./uploadDigi');
            //       if(url.length> 0 && url[url.length - 1] == 'uploadDigi'){
            //         url.pop();
            //         // navigate(url.join('/'))
            //         navigate(`/case-initiation/check-detail/${reference}/3`)
            //       }
            //     }else{
            //       let err = 'Please save previous education forms first.'
            //       toast.error(err, {
            //         position: "top-right",
            //         autoClose: 5000,
            //         hideProgressBar: false,
            //         closeOnClick: true,
            //         pauseOnHover: true,
            //         draggable: true,
            //         progress: undefined,
            //       });
        
            //     }
        
            //   }
            
            // }else{
            //   let err = 'Please save current education form'
            //       toast.error(err, {
            //         position: "top-right",
            //         autoClose: 5000,
            //         hideProgressBar: false,
            //         closeOnClick: true,
            //         pauseOnHover: true,
            //         draggable: true,
            //         progress: undefined,
            //       });
            // }
          
        
            // if(uploadFlag){
            //   // logic to check all tabs completed status
            // }
        
            // setActiveTab(index);
        
            // if(tabsFieldData[index-1]?.university_board?.field_value == "Other" || tabsFieldData[index-1]?.university_board?.field_value == ""){
            //   setShowAllFields(false);
            // }else{
            //   setShowAllFields(true);
            // }
          }; 

          const reRenderAgain2 = (value) => {
            props.reRenderAgain(value, activeTab);
          }
          
          
          // const getUploadedFilesCount = (checksDetails) => {
          //   let uploadedFilesCount = {};
          //   for (let i in checksDetails) {
          //     let obj = {};
          //     for (let j in checksDetails[i].required_documents) {
          //       let count = 0;
          //       for (let k in checksDetails[i].uploaded_documents) {
          //         if (
          //           checksDetails[i].uploaded_documents[k].document_id ==
          //           checksDetails[i].required_documents[j].id
          //         ) {
          //           count++;
          //         }
          //       }
          //       obj[`${checksDetails[i].required_documents[j].id}`] = count;
          //     }
          //     uploadedFilesCount[i] = obj;
          //   }
          //   setUploadedFilesCount(uploadedFilesCount);
          // };
          // // alert(JSON.stringify(uploadedFilesCount));
        
          // const getDocumentIdMandatory = (checksDetails) => {
          //   let uploadedFilesCount = {};
          //   for (let i in checksDetails) {
          //     let obj = {};
          //     for (let j in checksDetails[i].required_documents) {
          //       obj[
          //         `${checksDetails[i].required_documents[j].id}`
          //       ] = `${checksDetails[i].required_documents[j].is_mandatory}`;
          //     }
          //     uploadedFilesCount[i] = obj;
          //   }
        
          //   // alert(JSON.stringify(uploadedFilesCount));
          //   setDocumnetMandatory(uploadedFilesCount);
          // };  
          const uploadCallback = (value) => {
            if(value?.doc_count == 0){
              props?.reRenderAgain2({}, activeTab)
            }else if(value?.doc_count){
              props?.reRenderAgain2({}, activeTab, value?.doc_count)
            }else {
              props?.reRenderAgain2(value?.data, activeTab)
            }
          }

          const changeTab = (index) => {
            setActiveTab(activeTab+1);
          }

          console.log(uploadedFilesCount, 'uploadddd')

    return (
        <>
            {isLoading && <Loader />}
            <div className="p-3" style={{ background: "#F9FAFB" }}>
                {/* <div className="formHeading border-bottom">
                    <FormHeading
                        heading="Form 16"
                    />
                </div> */}

                <div className="d-flex justify-content-between align-items-center flex-column-mbl flex-start-mbl">
                  <div>
                    <StepCount activeTab={"form16"} />
                    <h2 className="fnt-smi-bld">Form 16</h2>
                  </div>
                
                </div>

                <div className="col-auto p-0 m-0 w-100">
            <div className="navtab st-navtab">
              <ul
                className="nav st-nav-tabs nav-tabs btn-group border-0"
                role="group"
              >
                {allCheckData && Object.keys(allCheckData).length > 0 && allCheckData?.map((tab, index) => (
                  <li
                    key={index}
                    className={`nav-item st-nav-item rounded-0 ${
                      index + 1 === activeTab ? "active" : ""
                    }`}
                  >
                    <span
                      className="nav-link st-nav-link rounded-0"
                      onClick={() => {
                        handleTabClick(index + 1);
                        // setSelectedCaseCheckId(tab?.case_check_id);
                      }}
                      role="button"
                    >
                      {/* {tab.label} */}
                      {(allCheckData[index]?.check_status === 2 || allCheckData[index]?.check_status === 3) && (
                      <i class="fas fa-check-circle mr-1"></i>
                      )} 
                      {/* {checkName} {index + 1} */}
                       {/* Form {index + 1} */}
                       {allCheckData[index]?.IB_CHECK_NAME}
                    </span>
                  </li>
                ))}
              </ul>

              {/* { 
                allCheckData &&
                Object.keys(allCheckData).length > 0 && allCheckData?.map((tab, index) => {
                    })
                    }   */}

                {/* {
                    
                    
                    <FormFields 
                    fields={allCheckData[activeTab-1]?.fields}
                    />
                }     */}

              {/* {activeTab <= tabs.length && ( */}
                <div className="tab-content border-top my-4 pt-4">
                  {Object.values(allCheckData)?.map((tab, index) => {
                    let caseChId,
                      docVis,
                      slug,
                      showVal,
                      verficationSourceName,
                      verficationSourceid;
                    if (tab && allCheckData) {
                      caseChId = allCheckData[index]?.case_check_id;
                      docVis = allCheckData[index]?.document_visibility;
                      slug = "verificationName_" + allCheckData[index]?.case_check_id;
                      verficationSourceName = allCheckData[index]?.verification_source_name;
                      verficationSourceid = allCheckData[index]?.verification_source_id;
                      // console.log("index = ", index);
                      // if(tabsFieldData[index]?.fields?.university_board?.field_value == "Other" || tabsFieldData[index]?.fields?.university_board?.field_value == "" ){
                      //   showVal = false
                      //   // setShowAllFields(false);
                      // }else{
                      //   showVal = true;
                      //   // setShowAllFields(true);
                      // }
                    }
                    // console.log('digiTab' , tabsFieldData)
                    return (
                      <div
                        key={`tab-${index}`}
                        className={`tab-pane ${
                          index + 1 === activeTab ? "active" : ""
                        }`}
                      >
                        {/* {tabsFieldData} */}
                        <FormFields
                          fields={allCheckData[activeTab-1]?.fields}
                          active={activeTab}
                          requiredDocs={allCheckData[activeTab-1]?.required_documents}
                          reRenderAgain={reRenderAgain2}
                          key={allCheckData[index]?.case_check_id}
                          // getDocumentIdMandatory={getDocumentIdMandatory}
                          // getUploadedFilesCount={getUploadedFilesCount}
                          uploadedFilesCount={uploadedFilesCount}
                          documnetMandatory={documnetMandatory}
                          uploadRecord={props?.uploadRecord}
                          uploadCallback={uploadCallback}
                          // fieldData={tabsFieldData[index]}
                          setActiveTab={setActiveTab}
                          handleTabClick={handleTabClick}
                          changeTab={changeTab}
                          getDataCallback={props?.getDataCallback}
                          // activeTab={activeTab}
                          // digiLockerUniversityList={digiLockerUniversityList}
                          // modeOfQualificationOptions={
                          //   modeOfQualificationOptions
                          // }
                          // qualificationOptions={qualificationOptions}
                          // veridficationCourseNameOptions={
                          //   veridficationCourseNameOptions
                          // }
                          caseCheckId={allCheckData[activeTab-1]?.case_check_id}
                          // cisSlug={slug}
                          documentVisibility={docVis}
                          // moqOptions={moqOptions[index]}
                          // universitySelectHandler={universitySelectHandler}
                          // showAllDigiFields={showAllFields}
                          // selectHandler={selectHandler}
                          index={activeTab-1}
                          // verficationSourceName={verficationSourceName}
                          // verficationSourceid={verficationSourceid}
                          // selectHandler2={selectHandler2}
                          // updateOtherInstitute={updateOtherInstitute}
                          // otherInstituteObj={otherInstituteObj}
                          // setOtherInstituteObj={setOtherInstituteObj}
                          // univTypeProp={univType[index]}
                          // key={`education-${index}`}
                          // education={education}
                          // textHandlerMulti={textHandler}
                          // saveHandler={saveHandler}
                          // newRecord={newRecord[index]}
                          // showVal={showVal}
                          // setMoqOptionsCallback={setMoqOptionsCallback}
                          // allDisabled={allDisabled}
                          // handleNewRecord={handleNewRecord}
                          // allFields={allFields}
                          // addMore={addMore}
                        />
                      </div>
                    );
                  })}
                </div>
              
            </div>
                </div>

                {formData?.showProfilePreview == 1 && (
                  <div className="row">
                    <div className="col-auto d-flex justify-content-between align-items-center">
                      <button
                        className="btn btn-primary btn-lg btn-block mt-2"
                        onClick={(e) => handleSubmitForPreview(e)}
                      >
                        {clientId == 459831 ? "Preview" : "Submit for Preview"}
                      </button>
                    </div>
                    <div className="col-auto d-flex justify-content-between align-items-center mt-2">
                      <small className="text-muted">
                        Please complete all the mandatory fields before final
                        submission
                      </small>
                    </div>
                  </div>
                )}
            </div>
        </>
    );
};

export default MainFormForm16;
